<svelte:head>


</svelte:head>

<script>

export let slider_value = 0;

import { onMount, onDestroy } from 'svelte';

	onMount(async () => {

	});

	onDestroy(async () => {

	});

</script>

<style>
</style>




<input type="range" name="test-slider-001" bind:value={slider_value} min="1" max="100" step="0.1"><br/>
<input type="range" name="test-slider-002" value="0.2" min="0" max="1" step="0.1" ><br/>


